import React, { Component } from 'react';
import {
  Modal,
  Form,
  Button,
  Spinner
} from 'react-bootstrap';
import PropTypes from 'prop-types';

class K3TaskCreateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        type: '',
        name: '',
        description: '',
        content: '',
        task_report_id: '',
        status: 'pending',
        priority: 'medium',
        src_agent_id: '',
        target_agent_id: '',
        script_id: '',
        parent_task_id: '',
        children_task_ids: [],
        tags: '',
        input_data: '{}',
        output_data: '{}',
        error_message: '',
        metadata: '{}'
      },
      loading: false,
      isEditMode: false
    };
  }

  componentDidMount() {
    if (this.props.selectedTask) {
      this.setState({
        formData: {
          ...this.props.selectedTask,
          input_data: JSON.stringify(this.props.selectedTask.input_data || {}),
          output_data: JSON.stringify(this.props.selectedTask.output_data || {}),
          metadata: JSON.stringify(this.props.selectedTask.metadata || {})
        },
        isEditMode: true
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    try {
      const taskData = {
        type: this.state.formData.type,
        name: this.state.formData.name,
        description: this.state.formData.description,
        content: this.state.formData.content,
        task_report_id: this.state.formData.task_report_id,
        status: this.state.formData.status,
        priority: this.state.formData.priority,
        src_agent_id: this.state.formData.src_agent_id,
        target_agent_id: this.state.formData.target_agent_id,
        script_id: this.state.formData.script_id,
        parent_task_id: this.state.formData.parent_task_id,
        children_task_ids: this.state.formData.children_task_ids,
        tags: this.state.formData.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        input_data: JSON.parse(this.state.formData.input_data),
        output_data: JSON.parse(this.state.formData.output_data),
        error_message: this.state.formData.error_message,
        metadata: JSON.parse(this.state.formData.metadata)
      };

      await this.props.onCreateTask(taskData);
      this.handleClose();
    } catch (error) {
      console.error('Error creating task:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleClose = () => {
    this.setState({
      formData: {
        type: '',
        name: '',
        description: '',
        content: '',
        task_report_id: '',
        status: 'pending',
        priority: 'medium',
        src_agent_id: '',
        target_agent_id: '',
        script_id: '',
        parent_task_id: '',
        children_task_ids: [],
        tags: '',
        input_data: '{}',
        output_data: '{}',
        error_message: '',
        metadata: '{}'
      }
    });
    this.props.onHide();
  };

  render() {
    const { show, k3agents, k3scripts } = this.props;
    const { formData, loading, isEditMode } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? 'Edit Task' : 'Create New Task'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Source Agent</Form.Label>
              <Form.Select
                name="src_agent_id"
                value={formData.src_agent_id}
                onChange={this.handleChange}
                required
              >
                <option value="">Select Source Agent</option>
                {k3agents && k3agents.map(agent => (
                  <option key={agent._id} value={agent._id}>
                    [{agent.main_type} - {agent.sub_type}] {agent.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Target Agent</Form.Label>
              <Form.Select
                name="target_agent_id"
                value={formData.target_agent_id}
                onChange={this.handleChange}
                required
              >
                <option value="">Select Target Agent</option>
                {k3agents && k3agents.map(agent => (
                  <option key={agent._id} value={agent._id}>
                    [{agent.main_type} - {agent.sub_type}] {agent.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Script</Form.Label>
              <Form.Select
                name="script_id"
                value={formData.script_id}
                onChange={this.handleChange}
              >
                <option value="">Select Script</option>
                {k3scripts && k3scripts.map(script => (
                  <option key={script._id} value={script._id}>
                    {script.title}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select
                name="type"
                value={formData.type}
                onChange={this.handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="AI CHAT">AI CHAT</option>
                <option value="AI HELPER">AI HELPER</option>
                <option value="SCRIPT RUNNER">SCRIPT RUNNER</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={this.handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={formData.description}
                onChange={this.handleChange}
                rows={2}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                name="content"
                value={formData.content}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={formData.status}
                onChange={this.handleChange}
              >
                <option value="pending">Pending</option>
                <option value="in_progress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="failed">Failed</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Priority</Form.Label>
              <Form.Select
                name="priority"
                value={formData.priority}
                onChange={this.handleChange}
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="urgent">Urgent</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Parent Task ID</Form.Label>
              <Form.Control
                type="text"
                name="parent_task_id"
                value={formData.parent_task_id}
                onChange={this.handleChange}
                placeholder="Optional: Enter parent task ID"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Task Report ID</Form.Label>
              <Form.Control
                type="text"
                name="task_report_id"
                value={formData.task_report_id}
                onChange={this.handleChange}
                placeholder="Optional: Enter report ID"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Tags</Form.Label>
              <Form.Control
                type="text"
                name="tags"
                value={formData.tags}
                onChange={this.handleChange}
                placeholder="tag1, tag2, tag3"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Input Data (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="input_data"
                value={formData.input_data}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Output Data (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="output_data"
                value={formData.output_data}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Metadata (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="metadata"
                value={formData.metadata}
                onChange={this.handleChange}
                rows={3}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit} disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Create Task'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default K3TaskCreateModal; 